/* Projektangepasste V1-Datei. */
/* global axios */
(function (global) {
  "use strict";

  function normalizeApiBase(apiBase) {
    return String(apiBase || "").replace(/\/$/, "");
  }

  function httpClient() {
    return global.GLOBALAXIOS || global.axios;
  }

  function getToken() {
    try {
      if (typeof global.getOzgUserToken === "function") {
        var value = String(global.getOzgUserToken() || "").trim();
        if (value) return value;
      }
    } catch (e) {}
    return String(localStorage.getItem("ozgUserJwt") || localStorage.getItem("ozgJwt") || "").trim();
  }

  function camel(obj) {
    if (!obj || typeof obj !== "object") return obj;
    var out = {};
    Object.keys(obj).forEach(function (key) {
      var k = key.charAt(0).toLowerCase() + key.slice(1);
      out[k] = obj[key];
    });
    return out;
  }

  function normalizeEffective(payload) {
    payload = payload || {};
    var packages = payload.packages || payload.Packages || [];
    var components = payload.components || payload.Components || [];
    return {
      communityId: payload.communityId || payload.CommunityId,
      evaluatedAtUtc: payload.evaluatedAtUtc || payload.EvaluatedAtUtc,
      packages: packages.map(camel),
      components: components.map(camel)
    };
  }

  async function loadEffective(apiBase, scope, formId, options) {
  const normalizedScope = String(scope || "manager")
    .trim()
    .toLowerCase();

  const isWidget = normalizedScope === "widget";

  let url =
    normalizeApiBase(apiBase) +
    (
      isWidget
        ? "/packages/context/effective"
        : "/packages/me/effective"
    ) +
    "?scope=" +
    encodeURIComponent(normalizedScope);

  if (
    formId !== null &&
    formId !== undefined &&
    formId !== ""
  ) {
    url += "&formId=" + encodeURIComponent(formId);
  }

  const headers = {};

  if (isWidget) {
    const contextToken =
      options?.communityContextToken ||
      window.__ozgCommunityContextToken;

    if (contextToken) {
      headers["X-Community-Context"] = contextToken;
    }
  } else {
    const token = getToken();

    if (token) {
      headers.Authorization = "Bearer " + token;
    }
  }

  const response = await httpClient()({
    method: "get",
    url,
    headers
  });

  return normalizeEffective(response.data);
}

  function isPackageActive(effective, identifier) {
    var list = effective && Array.isArray(effective.packages) ? effective.packages : [];
    return list.some(function (item) {
      return item && item.identifier === identifier && (item.status === "active" || item.status === "cancellation_scheduled" || item.status === "non_renewing");
    });
  }

  function findRuleForComponent(rules, component, formId) {
    if (!component || !component.key) return null;
    return rules.find(function (rule) {
      if (!rule || rule.targetType !== "formio_component") return false;
      if (rule.formId && Number(rule.formId) !== Number(formId)) return false;
      return rule.componentKey === component.key;
    }) || null;
  }

  function appendBookingHint(component, text) {
    var hint = text || "Für diese Funktion ist ein zusätzliches Paket erforderlich.";
    component.properties = component.properties || {};
    component.properties.ozgPackageUnavailable = "true";
    component.properties.ozgPackageHint = hint;

    if (component.type === "panel" || component.type === "well" || component.type === "fieldset") {
      component.components = Array.isArray(component.components) ? component.components : [];
      var hintKey = "packageHint_" + String(component.key || "component");
      var exists = component.components.some(function (child) { return child && child.key === hintKey; });
      if (!exists) {
        component.components.unshift({
          type: "htmlelement",
          key: hintKey,
          tag: "div",
          input: false,
          tableView: false,
          className: "alert alert-info ozg-package-booking-hint",
          content: "<strong>Paket erforderlich</strong><br>" + escapeHtml(hint)
        });
      }
      return;
    }

    var existing = component.description ? String(component.description) + " " : "";
    component.description = existing + hint;
  }

  function applyUnavailableBehavior(component, rule) {
    var behavior = String(rule.behaviorWhenUnavailable || "hidden").toLowerCase();
    switch (behavior) {
      case "disabled":
        component.disabled = true;
        break;
      case "readonly":
        component.disabled = true;
        component.properties = component.properties || {};
        component.properties.ozgPackageReadonly = "true";
        break;
      case "show_booking_hint":
        component.disabled = true;
        appendBookingHint(component, rule.bookingHintText);
        break;
      case "hidden":
      default:
        component.hidden = true;
        break;
    }
  }

  function walkComponents(components, callback, parent) {
    if (!Array.isArray(components)) return;
    components.forEach(function (component) {
      if (!component) return;
      callback(component, parent || null);

      if (Array.isArray(component.components)) {
        walkComponents(component.components, callback, component);
      }
      if (Array.isArray(component.columns)) {
        component.columns.forEach(function (column) {
          if (column && Array.isArray(column.components)) {
            walkComponents(column.components, callback, component);
          }
        });
      }
      if (Array.isArray(component.rows)) {
        component.rows.forEach(function (row) {
          if (!Array.isArray(row)) return;
          row.forEach(function (cell) {
            if (cell && Array.isArray(cell.components)) {
              walkComponents(cell.components, callback, component);
            }
          });
        });
      }
      if (Array.isArray(component.tabs)) {
        component.tabs.forEach(function (tab) {
          if (tab && Array.isArray(tab.components)) {
            walkComponents(tab.components, callback, component);
          }
        });
      }
    });
  }

  function applyToFormDefinition(definition, effective, formId) {
    if (!definition || !Array.isArray(definition.components)) return definition;
    var rules = effective && Array.isArray(effective.components) ? effective.components : [];

    walkComponents(definition.components, function (component) {
      var rule = findRuleForComponent(rules, component, formId);
      if (!rule) return;

      var unavailable = rule.packageActive !== true || rule.permissionGranted !== true;
      if (unavailable) {
        applyUnavailableBehavior(component, rule);
      }
    });

    return definition;
  }

  function applyDomRule(rule) {
    if (!rule || !rule.domSelector) return false;
    var nodes;
    try {
      nodes = document.querySelectorAll(rule.domSelector);
    } catch (e) {
      console.warn("[PACKAGE] Ungültiger DOM-Selector", rule.domSelector, e);
      return false;
    }
    if (!nodes || nodes.length === 0) return false;

    var unavailable = rule.packageActive !== true || rule.permissionGranted !== true;
    nodes.forEach(function (node) {
      if (!unavailable) return;
      var behavior = String(rule.behaviorWhenUnavailable || "hidden").toLowerCase();
      if (behavior === "hidden") {
        node.hidden = true;
        node.style.display = "none";
      } else {
        node.disabled = true;
        node.setAttribute("aria-disabled", "true");
        node.setAttribute("data-ozg-package-blocked", "true");
      }

      if (behavior === "show_booking_hint") {
        var parent = node.parentNode;
        if (!parent) return;
        var id = "ozg-package-hint-" + String(rule.packageComponentDefinitionId);
        if (document.getElementById(id)) return;
        var hint = document.createElement("div");
        hint.id = id;
        hint.className = "alert alert-info ozg-package-booking-hint";
        hint.style.marginTop = "8px";
        hint.innerHTML = "<strong>Paket erforderlich</strong><br>" + escapeHtml(rule.bookingHintText || "Diese Funktion ist nicht gebucht.");
        parent.insertBefore(hint, node.nextSibling);
      }
    });
    return true;
  }

  function applyDomRules(effective, retries) {
    var rules = effective && Array.isArray(effective.components)
      ? effective.components.filter(function (r) { return r && (r.targetType === "vue_selector" || r.targetType === "dom_selector" || r.targetType === "menu_item"); })
      : [];
    var remaining = rules.filter(function (rule) { return !applyDomRule(rule); });
    var count = Number(retries || 0);
    if (remaining.length > 0 && count < 10) {
      setTimeout(function () { applyDomRules({ components: remaining }, count + 1); }, 250);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  global.OzgPackageGate = {
    loadEffective: loadEffective,
    isPackageActive: isPackageActive,
    applyToFormDefinition: applyToFormDefinition,
    applyDomRules: applyDomRules,
    walkComponents: walkComponents
  };
})(window);